<template>
  <div class="sticky-box">
    <div class="header">
      <div class="logo" style="flex: 1">
        <img class="logo-img cursor-pointer" @click="onLogoImageClick" src="@/assets/images/logo.jpeg" />
        <div
            v-if="!security && home && $route.path != '/subscribe' && $route.path != '/payment' && $route.path != '/checkout'"
            style="display: flex; flex-wrap: wrap; justify-content: flex-start; flex: 1"
        >
          <span class="cursor-pointer" @click="onAbout">{{ $t("other.about") }}</span>
          <span class="cursor-pointer" @click="onPlatform">{{ $t("other.platform") }}</span>
          <span class="cursor-pointer" @click="onFaq">{{ $t("other.faq") }}</span>
          <span class="cursor-pointer" @click="onContact">{{ $t("other.contact") }}</span>
        </div>
      </div>
      <div class="userinfo" v-if="!security && $route.path != '/subscribe' && $route.path != '/checkout'">

        <span class="cursor-pointer" v-if="$store.getters.language !== languageZhTc && home" @click="onLangText('zh_tc')">繁</span>
        <span class="cursor-pointer" v-else-if="home" @click="onLangText(languageEn)">EN</span>
<!--        <span class="cursor-pointer" v-if="$store.getters.language !== languageZhTc" @click="onLangText('zh_tc')">繁</span>-->
<!--        <span class="cursor-pointer" v-else-if="$store.getters.language !== languageEn" @click="onLangText(languageEn)">EN</span>-->
        <div v-if="$route.path != '/payment'" class="userinfo">
          <el-badge :value="countNewHomework" v-if="userInfo.roleName == roleNameStudent" class="item cursor-pointer">
            <i class="el-icon-s-order" @click="testMode" style="font-size: 30px;color: #9b9b9b"></i>
          </el-badge>
          <img class="cursor-pointer" v-if="userInfo.roleName == roleNameStudent" style="width: 1.7rem; height: 1.7rem" @click="help" src="@/assets/images/way.png" />
          <img class="cursor-pointer" style="width: 2rem; height: 2rem" @click="onWhatsapp" src="@/assets/images/phone.png" />
          <img class="cursor-pointer" v-if="userInfo.roleName == roleNameStudent" style="width: 2rem; height: 2rem" @click="onGacha" src="@/assets/images/ka.png" />
          <el-divider direction="vertical"></el-divider>
          <button v-if="home && userInfo.roleName != roleNameStudent" @click="onSubscribe" class="subscribe cursor-pointer">
            {{ $t("other.order") }}
          </button>
          <div class="cursor-pointer" v-if="userInfo.roleName != roleNameParent && userInfo.roleName != roleNameStudent" @click="onLogin">
            <img class="userInfo-avatar-img" src="@/assets/images/login.png" />
            {{ $t("other.login") }}
          </div>
          <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameParent">
            <div class="cursor-pointer">
              <img class="userInfo-avatar-img" src="@/assets/images/exit.png" />
              {{ $t("other.exit") }}
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="$router.push({ path: '/parentProfile' })"><span class="cursor-pointer">家長資料</span></el-dropdown-item>
              <el-dropdown-item divided @click.native.capture="onLogOut">
                <span class="cursor-pointer">{{ $t("other.exit") }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent">
            <el-avatar class="cursor-pointer" :src="getAvatar"></el-avatar>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="onAnswerResult"><span class="cursor-pointer">{{ $t("studentProgramme.answerRecord") }}</span></el-dropdown-item>
              <el-dropdown-item @click.native="onStudentAccount"><span class="cursor-pointer">{{ $t("studentProgramme.myFile") }}</span></el-dropdown-item>
              <el-dropdown-item ><span class="cursor-pointer">V260601a</span></el-dropdown-item>
              <el-dropdown-item divided @click.native.capture="onLogOut">
                <span class="cursor-pointer">{{ $t("other.exit") }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <div class="header-phone">
      <img
          :style="{ visibility: userInfo.roleName == roleNameStudent ? '' : '' }"
          src="@/assets/images/icon-more.png"
          class="cursor-pointer"
          @click="drawer = !drawer"
          style="height: 2rem; width: 2rem"
      />
      <!-- <i class="el-icon-more" @click="drawer = !drawer"></i> -->
      <el-drawer :visible.sync="drawer" direction="ltr" size="100%" :modal="false">
        <Menu @closeDrawer="drawer = false" :home="home"></Menu>
        <div slot="title" style="text-align: center">
          <img class="logo-img cursor-pointer" @click="onLogoImageClick" src="@/assets/images/logo.jpeg" />
        </div>
      </el-drawer>
      <img class="logo-img cursor-pointer" @click="onLogoImageClick" src="@/assets/images/logo.jpeg" />

      <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent">
        <el-avatar class="cursor-pointer" :src="getAvatar"></el-avatar>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="onAnswerResult"><span class="cursor-pointer">{{ $t("studentProgramme.answerRecord") }}</span></el-dropdown-item>
          <el-dropdown-item @click.native="onStudentAccount"><span class="cursor-pointer">{{ $t("studentProgramme.myFile") }}</span></el-dropdown-item>
<!--          <el-dropdown-item @click.native="onSelectSubscribed"><span class="cursor-pointer">{{ $t("studentProgramme.courseSwitching") }}</span></el-dropdown-item>-->
          <el-dropdown-item divided @click.native.capture="onLogOut">
            <span class="cursor-pointer">{{ $t("other.exit") }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="cursor-pointer" v-else-if="userInfo.roleName == roleNameParent" @click="onLogOut">{{ $t("dashboard.logOut") }}</span>
      <span v-else style="width: 2rem"></span>

    </div>

  </div>

</template>

<script>
import { logout } from "@/api/security";
import {removeToken, removeAll, getUserInfo, setUserInfo} from "@/utils/auth";
import Menu from "./Menu";
import cmi from "@/views/student-programme/cmi";
import {getCountNewHomework} from "@/api/homework";
import {getProfile} from "@/api/user";
export default {
  props: {
    security: {
      type: Boolean,
      default: false,
    },
    home: {
      type: Boolean,
      default: false,
    },
    noFaq: {
      type: Boolean,
      default: false,
    },
  },
  components: { Menu },
  data() {
    return {
      avatar: null,
      carts: [],
      detail: {},
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      whatsapp: "https://api.whatsapp.com/send/?phone=85260195577&text&type=phone_number&app_absent=0", //'https://chat.whatsapp.com/SomeLettersandsomeNUMBERS',
      drawer: false,
      // 用于存储定时器ID，以便在组件销毁时清除
      refreshTimer: null,
      countNewHomework: 0
    };
  },
  created() {
    // 组件创建时立即执行一次
    this.fetchCountNewHomework();
  },
  beforeUnmount() {
    // 组件销毁前，清除定时器，防止内存泄漏
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  },
  watch: {
    "$store.getters.language": {
      handler(v) {
        this.$i18n.locale = v;
      },
      deep: true,
    },
  },
  computed: {
    getAvatar() {
      let avatar = getUserInfo("userProfile").avatar;
      return this.avatar || avatar || this.circleUrl;
    },
  },
  mounted() {
    cmi.$on("avatarChange", (avatar) => {
      this.avatar = avatar;
    });
  },
  destroyed() {
    cmi.$off("avatarChange");
  },
  methods: {
    getUserInfo(){
      getProfile().then((v) => {
        if (this.userInfo.roleName == this.roleNameParent) {
          setUserInfo("userProfile", v.data);
        } else if (this.userInfo.roleName == this.roleNameStudent) {
          let detail = JSON.parse(JSON.stringify(v.data));
          detail.subscriptionIndex=0
          setUserInfo("userProfile", detail);
          this.$store.dispatch(
              "setGradeId",
              detail.subscriptions[detail.subscriptionIndex].gradeId
          );
          if(detail.studying==1){
            this.$i18n.locale = "en";
            this.$store.dispatch("setLanguage", "en");
          }else if(detail.studying==0){
            this.$i18n.locale = "zh_tc";
            this.$store.dispatch("setLanguage", "zh_tc");
          }
        }
      });
    },
    // 将数据获取逻辑封装成一个方法
    async fetchCountNewHomework() {
      if(this.userInfo.roleName == this.roleNameStudent){
        getCountNewHomework().then((v) => {
          this.countNewHomework=v.data;
          // if(this.countNewHomework>0){
          //   this.$router.push({ name: "testMode" });
          // }
        });
      }
    },
    onAbout() {
      this.$router.push({ name: "about" });
    },
    onPlatform() {
      this.$router.push({ name: "platform" });
    },
    onFaq() {
      this.$router.push({ name: "faq" });
    },
    onContact() {
      this.$router.push({ name: "contact" });
    },
    onSitemap() {
      this.$router.push({ name: "sitemap" });
    },
    onRefund() {
      this.$router.push({ name: "refund" });
    },
    onPrivacy() {
      this.$router.push({ name: "privacy" });
    },
    onDisclaimer() {
      this.$router.push({ name: "disclaimer" });
    },
    onLangText(v) {
      this.$i18n.locale = v;
      this.$store.dispatch("setLanguage", v);
      window.location.reload();
    },
    onWhatsapp() {
      window.open(this.whatsapp, "_blank");
    },
    onGacha() {
      const newPath = "/gacha";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    testMode(){
      const newPath = "/testMode";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    onSubscribe() {
      if (this.userInfo.roleName != this.roleNameStudent) this.$router.push({ name: "cart" });
    },
    onLogoImageClick() {
      if (this.userInfo.roleName == this.roleNameStudent) {
        this.$router.push({ path: "/adventure" });
      } else if (this.userInfo.roleName == this.roleNameParent) {
        this.$router.push({ path: "/studyRecordCount" });
      }else{
        this.$router.push({ path: "/home" });
      }
      this.drawer = false;
    },
    onLogin() {
      this.$router.push({ path: "/login" });
    },
    onAnswerResult() {
      this.$router.push({ path: "/answerResult" });
    },
    onStudentAccount() {
      this.$router.push({ path: "/studentAccount" });
    },
    onSelectSubscribed() {
      this.$router.push({ path: "/selectSubscribed" });
    },
    onLogOut() {
      this.$confirm("", "你確定登出嗎？\nAre you sure want to logout?", {
        confirmButtonText: "登出 Logout",
        cancelButtonText: "返回 Back",
        center: true,
        showClose: false,
        closeOnClickModal: false,
        customClass: "exit-box",
        cancelButtonClass: "exit-cancel",
        confirmButtonClass: "exit-confirm",
      })
          .then(() => {
            this.logout();
          })
          .catch(() => {});
    },
    toIsFirst() {
      this.detail = getUserInfo("userProfile");
      this.detail.avatar=null;
      setUserInfo("userProfile", this.detail);
      location.reload();
    },
    help() {
      this.$router.push({ path: "/help" });
    },
    logout() {
      let form = {
        refreshToken: this.refreshToken,
      };
      logout(form)
          .then(() => {
            removeToken();
            removeAll();
            window.sessionStorage.clear();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            removeToken();
            removeAll();
            window.sessionStorage.clear();
            this.$router.push({ path: "/login" });
          });
      removeToken();
      removeAll();
      window.sessionStorage.clear();
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky-box {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  z-index: 2000;
  box-shadow: 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
  font-size: 18px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.25rem;
  //padding: 0 1.25rem;
  padding: 0 1.5rem;
  background-color: #fff;
}

.logo {
  display: flex;
  align-items: center;
}
.logo-img {
  height: 3.25rem;
}
.logo-text {
  font-size: 1.25rem;
  font-weight: bold;
}
.cursor-pointer {
  margin: 0 1.25vw;
}
.userinfo {
  display: flex;
  align-items: center;
}
.subscribe {
  background: #fcc03a;
  box-shadow: 0px 0.375rem 0 #c28c00;
  border: none;
  color: #444444;
  border-radius: 100px;
  //padding:0.375rem 1.25rem;
  width: 100px;
  height: 25px;
  margin: auto 1rem;
  font-size: 18px;
}
.userinfo-cursor {
  cursor: pointer;
}
.userInfo-avatar-img {
  width: 1.4rem;
  vertical-align: sub;
  margin-right: 0.125rem;
}
.userInfo-avatar-img-avatar {
  width: 2rem;
}
.header-phone {
  display: none;
}
.el-dropdown {
  font-size: 1rem;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .header {
    display: none;
  }
  .header-phone {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 3.5rem;
    padding: 0 1.25rem;
    background-color: #fff;
    .logo-img {
      height: 2.5rem;
    }
  }
  .el-dropdown {
    font-size: 1.5625rem;
  }

  ::v-deep {
    .el-drawer__header {
      padding: 1.25rem;
      margin-bottom: 0;
      & .el-drawer__close-btn {
        position: absolute;
        right: 1.25rem;
      }
    }
  }
}
</style>